import {
  REPORT_DATE_TYPES,
  REPORT_NUMBER_TYPES
} from 'Components/UI/EAReport/constants'

const appendDateColumnProperties = (column) => {
  const { dataIndex } = column

  return {
    render: (_, record) => record[`${dataIndex}_str`],
    sorter: (a, b) =>
      a[`${dataIndex}_unix`] - b[`${dataIndex}_unix`] > 0 ? 1 : -1,
    ...column
  }
}

const appendNumberColumnProperties = (column) => {
  const { dataIndex } = column

  return {
    render: (_, record) => record[`${dataIndex}_str`],
    sorter: (a, b) =>
      a[`${dataIndex}_num`] - b[`${dataIndex}_num`] > 0 ? 1 : -1,
    ...column
  }
}

const appendColumnPropertiesByType = (column) => {
  if (REPORT_DATE_TYPES.includes(column.type)) {
    return appendDateColumnProperties(column)
  }

  if (REPORT_NUMBER_TYPES.includes(column.type)) {
    return appendNumberColumnProperties(column)
  }

  return column
}

export default appendColumnPropertiesByType
